/**
 * SN_SAI_KNW_REG_001_POP_002 — 제품 지식 작성 도움말 (2026-09-18, 2차 검토 확정)
 *
 * 지식 구분별 본문 양식과 예시. 화면 전용 팝업이라 DB 정의 없이 글만 보인다. [닫기] 로 닫는다.
 */
import React, { forwardRef, useImperativeHandle } from "react";

interface popupProps {
  modalRef?: any;
}

const ROWS: { kind: string; form: string; sample: string }[] = [
  { kind: "용어", form: "뜻 한두 문장 → 같은 말(동의어) → 쓰이는 화면",
    sample: "출하의뢰 : 수주한 품목을 창고에서 내보내 달라고 요청하는 문서.\n같은 말 : 출고요청, 출하요청\n화면 : 영업관리 › 출하의뢰등록" },
  { kind: "매뉴얼", form: "목적 한 줄 → 절차 1. 2. 3. → 주의사항",
    sample: "목적 : 수주를 출하의뢰로 넘긴다.\n1. 출하의뢰등록에서 [수주적용]\n2. 수주를 체크하고 확인\n3. 창고 · 수량을 넣고 [저장]\n주의 : 의뢰수량이 수주수량을 넘으면 저장되지 않는다." },
  { kind: "FAQ", form: "Q: 질문 한 줄 → A: 답변 → 관련 화면",
    sample: "Q: 출하의뢰를 저장했는데 고객 칸이 잠겼습니다.\nA: 수주적용을 받은 행은 고객을 바꿀 수 없습니다. 삭제 후 다시 만드세요.\n화면 : 출하의뢰등록" },
  { kind: "화면 업무명세", form: "아무 구분이나 · [화면] 칸에 메뉴를 고른다 → 목적 → 업무 흐름 → 상태값 → 계산 기준 → 앞뒤 업무 → 주의",
    sample: "목적 : 고객 주문을 받아 출하 · 매출의 시작점을 만든다.\n흐름 : 견적 → 수주등록 → 출하의뢰 → 출하 → 매출\n상태 : 작성 → 확정(수정 불가) → 마감\n계산 : 공급가액 = 수량 × 단가, 부가세 = 공급가액 × 10%\n앞 : 견적등록 · 뒤 : 출하의뢰등록\n주의 : 확정 뒤 단가를 바꾸려면 확정취소 후 수정" },
  { kind: "답변 규칙", form: "[영역] 제목 → - 규칙 한 줄씩",
    sample: "[숫자]\n- 숫자를 직접 계산하지 마라. 합계 · 건수는 조회에 맡긴다.\n[근거]\n- 화면에 없으면 Tool 로 조회한다. 조회해도 없으면 \"없습니다\" 라고 한다." },
];

const SN_SAI_KNW_REG_001_POP_002 = forwardRef(({ modalRef }: popupProps, ref: React.Ref<any>) => {
  useImperativeHandle(ref, () => ({
    getOkayData: async () => ({ closeFlag: true, rtnData: null }),
  }));

  return (
    <div className="h-full overflow-auto p-3 text-sm">
      <p className="mb-3">
        이름은 사용자가 챗봇에 묻는 말 그대로, 한 줄 설명은 목록에 실려 AI 가 "이런 지식이 있다" 를 아는 한 줄입니다. 본문은 구분별 양식을 따릅니다.
        가져온 후보(사용여부 꺼짐)는 본문을 이 양식으로 다듬은 뒤 사용여부를 켜 주세요.
      </p>
      <table className="w-full border-collapse">
        <thead>
          <tr style={{ backgroundColor: "#305496", color: "#fff" }}>
            <th className="border px-2 py-1 text-left" style={{ width: 90 }}>지식 구분</th>
            <th className="border px-2 py-1 text-left" style={{ width: 240 }}>본문 양식</th>
            <th className="border px-2 py-1 text-left">예시</th>
          </tr>
        </thead>
        <tbody>
          {ROWS.map((r) => (
            <tr key={r.kind}>
              <td className="border px-2 py-1 align-top font-semibold">{r.kind}</td>
              <td className="border px-2 py-1 align-top">{r.form}</td>
              <td className="border px-2 py-1 align-top whitespace-pre-wrap">{r.sample}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-3 text-gray-600">
        답변 규칙은 AI 가 답할 때마다 맨 앞에 붙는 기본 규칙입니다. 지우지 말고 고치세요. 저장하면 다음 질문부터 바로 적용됩니다.
      </p>
      <p className="mt-2 text-gray-600">
        [화면] 칸을 채운 지식은 그 화면의 업무명세서입니다. 사용자가 그 화면을 연 채 질문하면 본문이 통째로 AI 에 실리고, 다른 화면에서는 실리지 않습니다.
        본문은 8,000자까지 쓰입니다. 길면 같은 화면으로 여러 건 나눠 등록하세요.
      </p>
    </div>
  );
});

export default SN_SAI_KNW_REG_001_POP_002;
